import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { DocumentCategoryRow } from "../utils";
import styles from "../DocumentCategories.module.scss";

export const DescriptionCell = memo(function DescriptionCell({
    row,
}: CellContext<ViewTableFeatures, DocumentCategoryRow, unknown>) {
    const { description } = row.original;

    if (!description) {
        return <ViewTableCell />;
    }

    return (
        <ViewTableCell>
            <Tooltip
                content={
                    <span style={{ whiteSpace: "pre-line" }}>
                        {description}
                    </span>
                }
            >
                <div className={styles.description}>{description}</div>
            </Tooltip>
        </ViewTableCell>
    );
});
